import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [actions.CHAT_RESOURCES_FETCH_SUCCESS],
  entityType: 'chatResources'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatResources/byId/reducer.js
 **/